namespace $ {

	export class $shm_hitalama_map_component_compiler_cache extends $mol_object {

		@ $mol_mem
		static shared(): $shm_hitalama_map_component_compiler_cache { return new this }
		private connection: IDBDatabase | null = null

		destructor() {
			this.connection?.close()
			this.connection = null
			super.destructor()
		}

		@ $mol_mem
		database(): IDBDatabase | null {
			return this.$.$mol_error_fence(
				()=> $mol_wire_sync( this ).open(),
				()=> null,
			)
		}

		open() {
			return new Promise< IDBDatabase >( ( resolve, reject )=> {
				const request = this.$.$mol_dom_context.indexedDB.open( 'hitalama-component-compiler', 2 )
				request.onupgradeneeded = event => {
					const store = request.result.objectStoreNames.contains( 'compiled' )
						? request.transaction!.objectStore( 'compiled' ) : request.result.createObjectStore( 'compiled' )
					if( !store.indexNames.contains( 'saved_at' ) ) store.createIndex( 'saved_at', 'saved_at' )
					// Version 1 entries have no eviction timestamp. Artifacts are rebuildable.
					if( event.oldVersion === 1 ) store.clear()
				}
				request.onsuccess = ()=> {
					this.connection = request.result
					request.result.onversionchange = ()=> {
						request.result.close()
						this.connection = null
					}
					resolve( request.result )
				}
				request.onerror = ()=> reject( request.error )
			})
		}

		read( key: string ) {
			const db = this.database()
			if( !db ) return Promise.resolve( null )
			return new Promise< $shm_hitalama_map_component_compiler_output | null >( ( resolve, reject )=> {
				const request = db.transaction( 'compiled', 'readonly' ).objectStore( 'compiled' ).get( key )
				request.onsuccess = ()=> resolve( request.result ?? null )
				request.onerror = ()=> reject( request.error )
			})
		}

		read_many( keys: readonly string[] ) {
			const db = this.database()
			if( !db ) return Promise.resolve( keys.map( ()=> null ) )
			return new Promise< ( $shm_hitalama_map_component_compiler_output | null )[] >( ( resolve, reject )=> {
				const transaction = db.transaction( 'compiled', 'readonly' )
				const store = transaction.objectStore( 'compiled' )
				const values = keys.map( ()=> null as $shm_hitalama_map_component_compiler_output | null )
				keys.forEach( ( key, index )=> {
					const request = store.get( key )
					request.onsuccess = ()=> { values[index] = request.result ?? null }
				} )
				transaction.oncomplete = ()=> resolve( values )
				transaction.onerror = ()=> reject( transaction.error )
				transaction.onabort = ()=> reject( transaction.error )
			})
		}

		write( key: string, value: $shm_hitalama_map_component_compiler_output ) {
			return this.write_many([[ key, value ]])
		}

		write_many( values: readonly ( readonly [ string, $shm_hitalama_map_component_compiler_output ] )[] ) {
			const db = this.database()
			if( !db ) return Promise.resolve( false )
			return new Promise< boolean >( ( resolve, reject )=> {
				const transaction = db.transaction( 'compiled', 'readwrite' )
				const store = transaction.objectStore( 'compiled' )
				for( const [ key, value ] of values ) store.put({ ...value, saved_at: Date.now() }, key )
				const count = store.count()
				count.onsuccess = ()=> {
					let excess = count.result - 128
					if( excess <= 0 ) return
					const request = store.index( 'saved_at' ).openKeyCursor()
					request.onsuccess = ()=> {
						const cursor = request.result
						if( !cursor || excess-- <= 0 ) return
						store.delete( cursor.primaryKey )
						cursor.continue()
					}
				}
				transaction.oncomplete = ()=> resolve( true )
				transaction.onerror = ()=> reject( transaction.error )
				transaction.onabort = ()=> reject( transaction.error )
			})
		}

	}

}
